import type { ManagedReturnsTrialSubmissionInput } from "@redotech/merchant-sdk/rpc/schema/merchant-submissions/submit-managed-returns-trial";

export function isManagedReturnsTrialSubmissionStep(stepId: string): boolean {
  return stepId === "refulfillment" || stepId === "consolidation";
}

export function getManagedReturnsTrialSubmissionInput(
  stepId: string,
  form: {
    returnsManagement:
      | ManagedReturnsTrialSubmissionInput["returnsManagement"]
      | null;
    productHandling:
      | ManagedReturnsTrialSubmissionInput["productHandling"]
      | null;
  },
): ManagedReturnsTrialSubmissionInput | null {
  if (
    !isManagedReturnsTrialSubmissionStep(stepId) ||
    form.returnsManagement === null ||
    form.productHandling === null
  ) {
    return null;
  }

  return {
    returnsManagement: form.returnsManagement,
    productHandling: form.productHandling,
  };
}
